import React from 'react';

import styles from './style.module.scss';

const BaseBlock = ({ title, icon, children }) => {
  return (
    <div className={styles.card}>
      <div className={styles.cardHeading}>
        {icon}
        <span>{title}</span>
      </div>
      {children}
    </div>
  );
};

export default BaseBlock;
